// Types
import type { SelectOptionType } from "types"

export const statusList: SelectOptionType[] = [
  {
    label: "Review",
    value: "1"
  },
  {
    label: "Submit",
    value: "2"
  }
]